
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/should-you-rent-or-buy-a-home",
      function () {
        return require("private-next-pages/should-you-rent-or-buy-a-home.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/should-you-rent-or-buy-a-home"])
      });
    }
  